import { InvestOffer } from './types';

/**
 * Phase 1 slug derived from wine name + vintage. When the backend exposes a real
 * `slug` field on the offer, swap this for `offer.slug ?? offerToSlug(offer)`.
 */
export function offerToSlug(offer: Pick<InvestOffer, 'wineName' | 'name' | 'vintage'>): string {
  // `||` (not `??`) so empty strings also fall through to the next option.
  const label = offer.wineName || offer.name || '';
  const base = `${label}-${offer.vintage ?? ''}`.toLowerCase();
  return base.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export function findOfferBySlug(offers: InvestOffer[], slug: string): InvestOffer | undefined {
  return offers.find((o) => offerToSlug(o) === slug);
}
